/* eslint-disable react/jsx-boolean-value */
/* eslint-disable  @typescript-eslint/no-floating-promises */
/* eslint-disable  react-hooks/exhaustive-deps */
/* eslint-disable  import/order */
/* eslint-disable import/no-named-as-default */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cloneDeep, get, assign as loadshAssign, set } from 'lodash';

import FormDrawer from '~/components/FormDrawer';
import { ApplicationPayload } from '~/types/ApplicationPayload';
import buildNamePath from '~/utils/buildNamePath';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import { Shareholders } from '~/types/Shareholders';
import { getContactDataFromUpdatedList, getUpdatedShareholderData } from '~/utils/contacts';
import { useMutateContactsApi } from '~/controllers/contacts';
import { useGetApplication } from '~/controllers/wizard';

import IndividualForm, { formName } from './IndividualForm';
import { shareholdersKey } from '.';

interface Props extends Partial<FormItemInjectedProps<Shareholders>> {
  uid: string;
  onClose: () => void;
  refetchContacts: () => void;
  setSourceOfEditing: any;
}

const IndividualEdit: React.FC<Props> = (props) => {
  const { uid, onClose, refetchContacts, setSourceOfEditing } = props;
  const { value, onChange } = props as FormItemInjectedProps<Shareholders>;
  const { t } = useTranslation('fillApplication');
  const [updatedData, setUpdatedData] = useState<any>({});
  const [rerender, setRerender] = useState<any>(false);
  const contactsMutation = useMutateContactsApi();
  const shareholdersFormState = { shareholders: value };
  const currentIndex = value?.individuals?.findIndex((item) => item?.data?.uid === uid) ?? 0;

  const onFinish = async (newValues: ApplicationPayload | any) => {
    const updatedIndividual = newValues?.shareholders?.individuals[currentIndex];
    const individuals: any = value?.individuals;
    const updatedShareholdersData = {
      ...value,
      individuals: individuals?.toSpliced(currentIndex, 1, updatedIndividual),
    };

    const updatedContactFromContactsList = await getContactDataFromUpdatedList(updatedIndividual);
    const updatedContactListIndividual = loadshAssign(updatedContactFromContactsList, updatedIndividual.data);
    contactsMutation.mutate(updatedContactListIndividual);

    onChange(updatedShareholdersData);
    refetchContacts();
    setSourceOfEditing('shareholder');
    onClose();
    setRerender((prev: any) => !prev);
  };
  useEffect(() => {
    getUpdatedShareholderData({ existedData: { ...shareholdersFormState[shareholdersKey] } }).then((data) => {
      setUpdatedData({ shareholders: { ...data } });
    });
  }, [JSON.stringify(shareholdersFormState), shareholdersKey, rerender]);

  return (
    <FormDrawer
      id="individualEditDrawer"
      open={!!uid}
      onClose={onClose}
      title={t('Edit Individual shareholder')}
      formName={formName}
    >
      <IndividualForm
        onFinish={onFinish}
        n={buildNamePath([shareholdersKey, 'individuals', currentIndex])}
        initialValues={updatedData}
        shareholderType="INDIVIDUAL"
        edit
      />
    </FormDrawer>
  );
};

export default IndividualEdit;
